import { cargoDims } from "../summary";
import { useQuoteCopy } from "../i18n/QuoteCopyContext";
import type { CargoLine } from "../types";

export function CargoTable({ cargo }: { cargo: CargoLine[] }) {
  const copy = useQuoteCopy();
  return (
    <div className="summary-table-wrap">
      <table className="summary-table">
        <thead>
          <tr>
            <th>{copy.t("shipment.qty")}</th>
            <th>{copy.t("shipment.type")}</th>
            <th>{copy.t("shipment.dims")}</th>
            <th>{copy.t("shipment.stackable")}</th>
          </tr>
        </thead>
        <tbody>
          {cargo.map((line) => (
            <tr key={line.id}>
              <td>{line.qty || "0"}</td>
              <td>{copy.palletLabel(line.type)}</td>
              <td>
                {line.sizeMode === "ldm"
                  ? cargoDims(line)
                  : `${cargoDims(line)}${line.height ? `\u00d7${line.height}` : ""}`}
              </td>
              <td>{line.stack ? copy.t("common.yes") : copy.t("common.no")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
